import type { PolicyCheckData } from '@newfront-insurance/ai-api';
import { IconTick, colors, IconExternal2, TextLink } from '@newfront-insurance/core-ui';

export function PolicyCheckingStatusCard({ data }: { data: PolicyCheckData }) {
  return (
    <div className="flex w-full flex-col gap-4 rounded-md border py-4 sm:px-4">
      <div className="flex items-center gap-3">
        <IconTick color={colors.grass['500']} size={16} />
        <div className="flex flex-col">
          <div className="text-steel-500 font-semibold">Policy check completed</div>
        </div>
        <div className="ml-auto flex items-center gap-2">
          <TextLink href={data.resultUrl} target="_blank" underline={false}>
            <div className="flex items-center gap-3">
              <IconExternal2 />
              View full analysis
            </div>
          </TextLink>
        </div>
      </div>
    </div>
  );
}
